import styled from 'styled-components';

const NavWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2.5rem 0 2rem 0;
`;

export default NavWrapper;
